var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditFillImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6285 7.7263L17.8586 5.49548C18.7084 4.6454 19.1334 4.22035 19.6295 4.07752C19.991 3.97345 20.3746 3.97345 20.7361 4.07752C21.2322 4.22035 21.6571 4.6454 22.5069 5.49549C23.3563 6.3451 23.781 6.76991 23.9237 7.26585C24.0277 7.62724 24.0277 8.01062 23.9237 8.37201C23.781 8.86795 23.3563 9.29276 22.5069 10.1424L20.3014 12.3486C18.363 11.2369 16.7542 9.63976 15.6285 7.7263ZM14.1743 9.18098L5.9365 17.4213C5.51157 17.8464 5.29911 18.0589 5.15943 18.32C5.01975 18.581 4.96083 18.8757 4.84299 19.4651L4.06572 23.3526C3.99922 23.6853 3.96597 23.8516 4.06058 23.9462C4.15519 24.0408 4.3215 24.0075 4.6541 23.941L8.53951 23.1636L8.53955 23.1636L8.53959 23.1636C9.12908 23.0457 9.42384 22.9867 9.68495 22.8469C9.94608 22.7071 10.1586 22.4945 10.5837 22.0693L18.8436 13.8068C16.9561 12.6309 15.3615 11.0471 14.1743 9.18098Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditFillImg);
export default __webpack_public_path__ + "static/media/edit_fill_img.91af2ccc77ae6b61b4a4e968574ccdd9.svg";
export { ForwardRef as ReactComponent };